module.exports = __webpack_public_path__ + "img/options-mdm.c5497c6c.svg";